import jszip from 'jszip';
window.jszip = jszip;